import { useMemo } from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { usePetitionStats } from '../../../hooks/petitionStats';

import type { MobileModalContext } from './types';

export function useMobileModalContext(): MobileModalContext {
	const pageData = usePetitionDetailsPageData();
	const pageUserData = usePetitionDetailsPageUserData();
	const stats = usePetitionStats();

	return useMemo(() => ({ pageData, pageUserData, stats }), [pageData, pageUserData, stats]);
}
